'use strict';

namespace Booking {

    class ModalLink {

        private modalType:string;

        constructor(
            private $element:JQuery,
            private $location:ng.ILocationService,
            private currentUser:any,
            private accountMenuService: any,
            private postBookingLookup:any,
            private modalService: any,
            private analytics: any
            ){}

            select(event) {
                switch(this.modalType) {
                    case 'termsconditions':
                        this.modalService.launch('partials/popups/agencyterms');
                    break;
                    case 'unsubscribe':
                        this.analytics.track('mixpanel', 'GDPRUnsubscribe');
                        this.modalService.launch('partials/popups/unsubscribe');
                    break;
                    default:
                        this.manage();
                    break;
                }
            }

            manage() {
                if (this.currentUser.AnonSignedIn && !this.currentUser.SignedIn) {
                    return this.postBookingLookup.redirect();
                }
                if (!this.currentUser.AnonSignedIn && this.currentUser.SignedIn) {
                    return this.$location.path('dashboard/bookings/current');
                }
                return this.accountMenuService.launchOption('bookingsignin');
            }

        }

    angular
        .module('core')
        .directive('modalLink', (): ng.IDirective => {
            return {
                restrict: 'A',
                replace: true,
                transclude: true,
                scope: {},
                bindToController: {
                    modalType: '@'
                },
                controller: ModalLink,
                controllerAs : 'ml',
                template : '<a ng-click="ml.select()" ng-transclude></a>'
            };
        });

}
